import { Direction } from '@prisjakt/ui';
import { H4Text } from '@prisjakt/ui/text/variants';
import { useAppContext } from '@prisjakt/ui-app-context';
import React, { ReactElement } from 'react';
import { PriceDisplay } from 'src/components/price-list/types';
import { Brand, Price, ProductPageQuery } from 'src/types';
import { PriceRow } from '..';
import { PriceRowContextContainer } from '../../../price-row-context';
import {
  Ribbon,
  IconWrapper,
  InfoIcon,
  PrisjaktIcon,
  Tooltip,
  withOurChoiceStyles,
  Wrapper,
} from './styles';
import { CurrentCampaign } from 'src/areas/product/types';
import { Offer } from '../../types';
import { useTheme } from 'styled-components';

type Props = {
  ourChoice: Price;
  product: ProductPageQuery['product'];
  priceDisplay: PriceDisplay;
  campaign: CurrentCampaign;
  offer: Offer;
};

export const OurChoice: React.FC<Props> = ({
  ourChoice,
  product,
  priceDisplay,
  campaign,
  offer,
}) => {
  const { t } = useAppContext();

  if (!product) {
    return null;
  }

  return (
    <>
      <H4Text>
        {t('product', 'prices.our-choice')}{' '}
        <Tooltip
          placement={Direction.Right}
          title={t('product', 'prices.our-choice-explanation')}
        >
          <InfoIcon color="base600" size={15} />
        </Tooltip>
      </H4Text>

      <PriceRowContextContainer
        key={ourChoice.id}
        productId={product.id}
        productName={product.name}
        productImage={product.media.first}
        brand={product.brand as Brand}
        priceDisplay={priceDisplay}
        campaign={campaign}
        showExpandButton
        offer={offer}
        position="productHeader"
        isOurChoice
        forceMobileView
      >
        <OurChoiceWrapper withShadow>
          <PriceRow
            item={product.prices?.ourChoice as Price}
            index={0}
            key={0}
          />
        </OurChoiceWrapper>
      </PriceRowContextContainer>
    </>
  );
};

export type OurChoiceWrapperProps = {
  children: ReactElement;
  className?: string;
  withShadow?: boolean;
};

export const OurChoiceWrapper = withOurChoiceStyles(
  ({ children, className }) => {
    const { colors } = useTheme();
    if (!children) {
      return null;
    }

    return (
      <Wrapper>
        <Ribbon>
          <IconWrapper>
            <PrisjaktIcon color={colors.positive500} size={22} />
          </IconWrapper>
        </Ribbon>
        {React.cloneElement(children, {
          className,
        })}
      </Wrapper>
    );
  }
);
